/* KILLIK — GinFinity swipe section.
   Each slide's backdrop is the gin's own render with the bottle removed (a "plate"), pinned so the
   cut-out lands back on its rendered light and floor shadow. The section colour blends between
   backdrops as you swipe. Set up per section, and again when the theme editor redraws it. */
(() => {
  'use strict';
  // size of the built-in plates and the bottle's box inside them, in render pixels
  const PLATE = { w: 3240, h: 2880, boxX: 1335, boxY: 835, boxH: 1170 };
  const pad = n => String(n).padStart(2, '0');
  const rgb = h => { const m = /^#?([0-9a-f]{6})$/i.exec(h || ''); const v = m ? parseInt(m[1], 16) : 0x3b3330; return [v >> 16, (v >> 8) & 255, v & 255]; };
  const mix = (a, b, t) => a.map((v, k) => Math.round(v + (b[k] - v) * t));

  function init(sec) {
    if (!sec || sec.dataset.ready) return;
    const track = sec.querySelector('[data-gin-track]');
    if (!track) return;
    const slides = [...track.querySelectorAll('.gin-slide')];
    if (!slides.length) return;
    sec.dataset.ready = '1';
    const dots = [...sec.querySelectorAll('[data-gin-dots] button')];
    const label = sec.querySelector('[data-gin-count-label]');
    const cols = slides.map(s => rgb(s.dataset.bg));
    const N = slides.length;
    let active = -1;

    function placePlates() {
      slides.forEach(slide => {
        const url = slide.dataset.plate, img = slide.querySelector('img');
        if (!url || !img || !img.offsetHeight) { slide.style.backgroundImage = ''; return; }
        let x = img.offsetLeft, y = img.offsetTop, el = img.offsetParent;
        while (el && el !== slide) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
        const k = img.offsetHeight / PLATE.boxH;
        slide.style.backgroundImage = `url(${url})`;
        slide.style.backgroundSize = `${PLATE.w * k}px ${PLATE.h * k}px`;
        slide.style.backgroundPosition = `${x - PLATE.boxX * k}px ${y - PLATE.boxY * k}px`;
      });
    }
    function update() {
      const p = track.scrollLeft / track.clientWidth;
      const i = Math.max(0, Math.min(N - 1, Math.floor(p)));
      const t = Math.min(1, Math.max(0, p - i));
      sec.style.setProperty('--gbg', `rgb(${mix(cols[i], cols[Math.min(i + 1, N - 1)], t)})`);
      const now = Math.round(p);
      if (now === active) return;
      active = now;
      slides.forEach((s, k) => s.classList.toggle('on', k === now));
      dots.forEach((d, k) => d.setAttribute('aria-current', k === now));
      if (label) label.textContent = `${pad(now + 1)} / ${pad(N)}`;
    }
    const go = i => track.scrollTo({ left: Math.max(0, Math.min(N - 1, i)) * track.clientWidth, behavior: 'smooth' });

    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => { placePlates(); update(); });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    sec.querySelector('[data-gin-prev]')?.addEventListener('click', () => go(active - 1));
    sec.querySelector('[data-gin-next]')?.addEventListener('click', () => go(active + 1));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
    });
    // other sections (the Rum | Gin list) ask for a particular gin
    sec.addEventListener('gin:show', e => go(e.detail));
    Promise.all([...track.querySelectorAll('img')].map(im => (im.decode ? im.decode().catch(() => {}) : Promise.resolve()))).then(placePlates);
    placePlates();
    update();
  }

  const initAll = (root = document) => root.querySelectorAll('.gin[data-gin-count]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', e => initAll(e.target));
})();
